import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import Popup from 'reactjs-popup';
import { ApplicationService } from './../../service/application.service';
import RegionCountry from './RegionCountry';
import Alert from '../common/Alert';

import '../../../node_modules/reactjs-popup/dist/index.css';
import '../../../node_modules/ag-grid-community/styles/ag-grid.css';
import '../../../node_modules/ag-grid-community/styles/ag-theme-alpine.css';

const NewApplication = (params) => {
    const applicationService = new ApplicationService();

    const [name, setName] = useState('');
    const [label, setLabel] = useState('');
    const [brandLookUp, setBrandLookUp] = useState('');
    const [description, setDescription] = useState('');

    const [metadatas, setMetadatas] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [regions, setRegions] = useState([]);

    const [appMetadatas, setAppMetadatas] = useState([]);
    const [appCompanies, setAppCompanies] = useState([]);
    const [appRegions, setAppRegions] = useState([]);

    const [isAlert, setIsAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [message, setMessage] = useState([]);

    const setFormInput = (e, tag = undefined) => {
        if (e.target !== undefined) {
            tag = e.target.name;
        }

        if (tag === "name") {
            setName(e.target.value);
            removeMessage(1);
        }
        else if (tag === "lebel") {
            setLabel(e.target.value);
            removeMessage(2);
        }
        else if (tag === "brandLookUp") {
            setBrandLookUp(e.target.value);
            removeMessage(3);
        }
        else if (tag === "description") {
            setDescription(e.target.value);
        }
        else if (tag === "metadata") {
            const mdatasAll = getMetadata(e);
            setAppMetadatas(mdatasAll);
            removeMessage(4);
        }
        else if (tag === "company") {
            setAppCompanies(e);
        }
        else if (tag === "region") {
            setAppRegions(e);
        }
    };

    const checkValidation = () => {
        let result = true;
        let newMessage = [];

        if (!name || name.length === 0) {
            newMessage.push({ id: 1, text: "Application name is required" });
            result = false;
        }

        if (!label || label.length === 0) {
            newMessage.push({ id: 2, text: "Application label is required" });
            result = false;
        }

        if (!brandLookUp || brandLookUp.length === 0) {
            newMessage.push({ id: 3, text: "Application brand lookup is required" });
            result = false;
        }

        if (!appMetadatas || appMetadatas.length === 0) {
            newMessage.push({ id: 4, text: "Application metadatas are required" });
            result = false;
        }

        setMessage(newMessage);
        return result;
    };

    const removeMessage = (id) => {
        if (message.length > 0) {
            let newMessage = message.filter((m) => {
                return (m.id !== id);
            });
            setMessage(newMessage);
        }
    };

    const saveUMApplication = async () => {
        if (checkValidation() === true) {
            let application = {
                id: (params.id ? params.id : 0),
                name: name,
                label: label,
                description: description ? description : "",
                brandLookUp: brandLookUp,
                dateCreated: new Date(),
                dateModified: new Date(),
                companies: appCompanies,
                regions: appRegions,
                metadataList: appMetadatas
            };

            let saveResult = await applicationService.saveApplication(application);
            if (saveResult.status === 200 && saveResult.data.isSuccess === true) {
                setAlertMessage("Application data has been saved successfully");
                alertOn(true);
                params.callBack();
            }
            else {
                setAlertMessage(saveResult.data.message);
                alertOn(true);
            }
        }
    };

    const getMetadata = (m_data) => {
        let mdata = (m_data ? m_data : []);
        let metadata = mdata.filter((m) => {
            return (m.label !== "Country" && m.label !== "Company");
        });
        metadata.push({ value: 2, label: "Country" });
        metadata.push({ value: 3, label: "Company" });
        metadata = metadata.sort((r1, r2) => (r1.value > r2.value) ? 1 : (r1.value < r2.value) ? -1 : 0);
        return metadata;
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await applicationService.getApplicationById(params.id);

                setName(result.data.application.name);
                setLabel(result.data.application.label);
                setDescription(result.data.application.description);
                setBrandLookUp(result.data.application.brandLookUp);

                setMetadatas(result.data.metadatas);
                setCompanies(result.data.companies);
                setRegions(result.data.regions);

                const mdatas = getMetadata(result.data.appMetadata);
                setAppMetadatas(mdatas);

                setAppCompanies(result.data.appCompanies);
                setAppRegions(result.data.appRegions);
                console.log("application data loaded");
            } catch (error) {
                console.error(error);
            }
        };

        fetchData();
    }, []);

    const alertOff = () => {
        setIsAlert(false);
        params.onClose();
    };

    const alertOn = () => {
        setIsAlert(true);
    };

    return (
        <>            
            {isAlert && <div><Alert type="error" message={alertMessage} callBack={alertOff} /></div>}

            <div className="card" style={{ width: "675px", marginTop: "-5px", marginLeft: "-5px", marginBottom: "-5px", marginRight: "-5px" }}>
                <h5 className="card-header py-3">
                    <i className="fa fa-folder-open-o" aria-hidden="true"></i> Application
                </h5>
                <div className="card-body">
                    <div>
                        {(message.length > 0) ?
                            <ul>
                                {message.map(m =>
                                    <li style={{ color: "red" }} key={m.id}>{m.text}</li>
                                )}
                            </ul>
                            : ""}
                    </div>

                    <div className="ag-theme-alpine" style={{ height: "400px", marginRight: "-15px", overflowY: "auto" }}>
                        <div className="col-md-12">
                            <div className="form-group">
                                <div className="row">
                                    <div className="col-md-9">
                                        <label>Name</label>
                                        <input type="text" className="form-control" id="name" name="name" required="required" value={name} onChange={(e) => { setFormInput(e) }} />
                                    </div>
                                    <div className="col-md-3">
                                        <label>Brand LookUp</label>
                                        <input type="text" className="form-control" id="brandLookUp" name="brandLookUp" required="required" value={brandLookUp} onChange={(e) => { setFormInput(e) }} />
                                    </div>
                                </div>
                            </div>


                            <div className="form-group">
                                <label>Label</label>
                                <input type="text" className="form-control" id="applicationlabel" name="lebel" required="required" value={label} onChange={(e) => { setFormInput(e) }} />
                            </div>

                            <div className="form-group">
                                <label>Description</label>
                                <input type="text" className="form-control" id="applicationdescription" name="description" value={description} onChange={(e) => { setFormInput(e) }} />
                            </div>

                            <div className="form-group">
                                <label>Approval Matrix Parameter</label>
                                <Select name="metadata" options={metadatas} isMulti value={appMetadatas} onChange={(e) => { setFormInput(e, 'metadata') }} required="required" />
                            </div>

                            <div className="form-group">
                                <label>Companies</label>
                                <Select options={companies} isMulti value={appCompanies} onChange={(e) => { setFormInput(e, 'company') }} required="required" />
                            </div>

                            <div className="form-group">
                                <label>Regions</label>
                                <div className="row">
                                    <div className="col-md-10">
                                        <Select options={regions} isMulti value={appRegions} onChange={(e) => { setFormInput(e, 'region') }} required="required" />
                                    </div>
                                    <div className="col-md-2">
                                        <Popup trigger={<button style={{ maxWidth: "100px", float: 'right' }} className="btn btn-secondary">Configure</button>} nested modal>{close => (<RegionCountry appRegions={appRegions} id={params.id} onClose={() => { close(); }}></RegionCountry>)}</Popup>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="card-footer text-muted">
                    <div style={{ textAlign: "center" }}>
                        <button className="btn btn-secondary" style={{ marginRight: "5px" }} onClick={saveUMApplication} >Save</button>
                        <button className="btn btn-secondary" onClick={params.onClose}>Close</button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default NewApplication;